import { useEffect } from "react";

/** The left and right arrow keys page the week, except while typing in a field. */
export const useArrowKeys = (onPrevious: () => void, onNext: () => void): void => {
	useEffect(() => {
		const handleKeyDown = (event: KeyboardEvent) => {
			// Key events come from elements, so the target is one.
			const target = event.target as HTMLElement;
			const isInputElement = target?.tagName === "INPUT" || target?.tagName === "TEXTAREA" || target?.contentEditable === "true";

			if (isInputElement) return;

			switch (event.key) {
				case "ArrowLeft":
					onPrevious();
					break;
				case "ArrowRight":
					onNext();
					break;
			}
		};

		window.addEventListener("keydown", handleKeyDown);
		return () => window.removeEventListener("keydown", handleKeyDown);
	}, [onPrevious, onNext]);
};
